import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { Routes } from '../constants/routes';

export const useRedirectToRef = ({ replace }: { replace?: boolean } = {}) => {
  const router = useRouter();
  const { ref } = router.query;

  const redirectToRef = useCallback(() => {
    const nextRoute = ref ? String(ref) : Routes.home();
    if (replace) {
      router.replace(nextRoute);
    } else {
      router.push(nextRoute);
    }
  }, [ref, replace, router]);

  return redirectToRef;
};
